import { connect } from 'react-redux';
import DashboardHeader from './DashboardHeader';
const mapStateToProps = (state) => ({
    token: state.roles.token,
});
export default connect(mapStateToProps)(DashboardHeader);
